module.exports = __webpack_public_path__ + "img/organization-img_2--tablet.92ad8bb.jpg";